import { useNavigate } from 'react-router-dom';
import { PRODUTO_CONFIG } from 'config/produto';
import { getProduto } from 'config/produto-env';
import { usePeriodoFase } from 'hooks/useControlDate';
import { formatarDiaMesAno } from 'utils/cronograma';
import { ROTA_PRE_INSCRICAO, SituacaoPreInscricao } from 'utils/destino-inicial';

const EDICAO = `${PRODUTO_CONFIG.titulo} 2027`;

/** Linhas do aviso e botão de cada situação; `fimPreInscricao` vem da controle_datas__c. */
function montarConteudo(situacao: SituacaoPreInscricao, fimPreInscricao: string) {
  if (situacao === 'pode_iniciar') {
    return {
      linhas: [`A pré-inscrição do ${EDICAO} está aberta! Pré-inscreva a sua iniciativa.`],
      actionLabel: 'FAZER PRÉ-INSCRIÇÃO',
      actionPath: ROTA_PRE_INSCRICAO,
    };
  }

  return {
    linhas: [
      `Você já tem uma iniciativa pré-inscrita no ${EDICAO}.`,
      fimPreInscricao && `A edição estará disponível até ${fimPreInscricao}.`,
    ].filter(Boolean),
    actionLabel: 'VER PRÉ-INSCRIÇÃO',
    actionPath: '/listagem',
  };
}

interface PreInscricaoNotificationProps {
  situacao: SituacaoPreInscricao | null;
  /** Ícone de aviso da home do produto (cada home tem o seu). */
  icone: string;
}

/**
 * Banner da home durante a pré-inscrição: convida a se inscrever ou a acompanhar a inscrição.
 * Usa o mesmo `notification-banner` dos avisos da home; o estilo vem da página.
 */
export function PreInscricaoNotification({ situacao, icone }: PreInscricaoNotificationProps) {
  const navigate = useNavigate();
  const { phaseIds } = PRODUTO_CONFIG;
  const periodo = usePeriodoFase(
    getProduto() === 'PREMIO_ELBB' ? phaseIds.ELBB_PRE_REGISTRATION : phaseIds.CONEXAO_PRE_REGISTRATION
  );

  if (!situacao) {
    return null;
  }

  const { linhas, actionLabel, actionPath } = montarConteudo(
    situacao,
    periodo ? formatarDiaMesAno(periodo.fim) : ''
  );

  return (
    <section className="notification-banner">
      <div className="notification-banner__content">
        <img src={icone} alt="" aria-hidden="true" className="notification-banner__icon" />
        <p className="notification-banner__text">
          {linhas.map((linha, i) => (
            <span key={i} className="block">
              {linha}
            </span>
          ))}
        </p>
        <button className="notification-banner__btn" onClick={() => navigate(actionPath)}>
          {actionLabel}
        </button>
      </div>
    </section>
  );
}
